var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.transport.planning)?_c('PlanningStops',{attrs:{"mobile":true},on:{"finishUpdate":function($event){return _vm.$router.push({ name: 'all-plannings', query: Object.assign({}, _vm.$route.query) })}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }